import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import { Modal, Tooltip } from "antd";
import { useState } from "react";
import moment from "moment";
import { AdminService } from "../../services/AdminService";

export default function ActivityLogs() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Admin',
            align: 'center',
            dataIndex: 'admin',
            key: 'admin',
            render: (value, record) => {
                return <Tooltip title={`ID: ${value.id} `}>{value.full_name}</Tooltip>
            },
        },
        {
            title: 'Action',
            align: 'center',
            dataIndex: 'type',
            key: 'type',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Entity Type',
            align: 'center',
            dataIndex: 'entity_type',
            key: 'entity_type',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Entity Id',
            align: 'center',
            dataIndex: 'entity_id',
            key: 'entity_id',
            render: (value, record) => {
                return value
            },
        },

        {
            title: 'Ip Address',
            align: 'center',
            dataIndex: 'ip_address',
            key: 'ip_address',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Browser',
            align: 'center',
            dataIndex: 'browser',
            key: 'browser',
            render: (value, record) => {
                return value
            },
        },


        {
            title: 'Created At',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (value, record) => {
                return moment(value).isValid() ? moment(value).format('DD-MM-YYYY HH:mm') : null
            },
        },

    ])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
        }
        const res = await AdminService.getActivityLogs(payload)
        return res
    }

    return (
        <>
            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
            </Modal>
            <AntTable
                refresh={refreshData}
                search
                title="Activity Logs"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>
    )
}
